<template>
  <div>
    health check
  </div>
</template>

<script>

export default {
  name: 'HealthCheck'
}
</script>

<style lang="scss" scoped="scoped">
</style>
